import React from "react";
import { motion } from "framer-motion";

function zigzag(x, y, width) {
  const step = width / 6;
  let d = `M ${x} ${y}`;
  for (let i = 1; i <= 6; i++) {
    d += ` L ${x + step * i} ${y + (i % 2 === 0 ? 3 : -3)}`;
  }
  return d;
}

// progress: number of completed journey stages (0-5). The Sadu tower builds bottom-up.
export default function SaduTower({ progress = 0, className = "" }) {
  const tiers = [0, 1, 2, 3, 4];
  return (
    <svg viewBox="0 0 120 150" className={className} data-testid="sadu-tower" style={{ overflow: "visible" }}>
      <defs>
        <linearGradient id="saduGrad" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#1e7a4d" />
          <stop offset="55%" stopColor="#734F96" />
          <stop offset="100%" stopColor="#D89134" />
        </linearGradient>
      </defs>
      {tiers.map((i) => {
        const w = 104 - i * 16;
        const x = 60 - w / 2;
        const h = 22;
        const y = 124 - i * 25;
        const done = progress > i;
        return (
          <g key={i}>
            <motion.rect
              initial={false}
              animate={{ opacity: done ? 1 : 0.14 }}
              transition={{ duration: 0.5, delay: done ? i * 0.12 : 0 }}
              x={x} y={y} width={w} height={h} rx="3"
              fill={done ? "url(#saduGrad)" : "transparent"}
              stroke={done ? "none" : "currentColor"}
              strokeWidth="1.5"
              className={done ? "" : "text-muted-foreground"}
            />
            {done && (
              <motion.path
                initial={{ opacity: 0 }}
                animate={{ opacity: 0.55 }}
                transition={{ delay: i * 0.12 + 0.2 }}
                d={zigzag(x + 6, y + h / 2, w - 12)}
                stroke="#fff" strokeWidth="1.5" fill="none"
              />
            )}
          </g>
        );
      })}
      <motion.path
        initial={false}
        animate={{ opacity: progress >= 5 ? 1 : 0.14, y: progress >= 5 ? 0 : 8 }}
        transition={{ duration: 0.5, delay: 0.5 }}
        d="M60 2 L69 24 L51 24 Z" fill="#D89134"
      />
    </svg>
  );
}
